// extracted by mini-css-extract-plugin
var _1 = "ix0n5TJW8D1YlqSq3zoj";
export { _1 as "repairTimeTable" }
